import { l as lazyInit } from "./utilities-2Suih3Nm.js";
import { w as waapi, o as onScroll } from "./scroll-xmwq2Kx4.js";
class MediaBg extends HTMLElement {
  connectedCallback() {
    this._parallax = this.dataset.parallax === "true";
    this._parallaxStrength = this.dataset.parallaxStrength;
    if (this.hasAttribute("data-visual-preview-mode")) {
      this._inner = this.querySelector(".media-bg-block-content");
      this.classList.add("active");
      if (this._parallax && this._inner) {
        this._initAnimejs();
      }
      return;
    }
    this._reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!this._parallax || this._reducedMotion) {
      this.classList.add("active");
      return;
    }
    this._inner = this.querySelector(".media-bg-block-content");
    if (!this._inner) {
      this.classList.add("active");
      return;
    }
    if (this.dataset.deferParallax === "true") {
      this.classList.add("active");
      return;
    }
    this.classList.add("active");
    if (typeof ViewTimeline !== "undefined") return;
    if (this.dataset.sectionIndex === "1") {
      this._initAnimejs();
    } else {
      lazyInit(this, () => this._initAnimejs());
    }
  }
  disconnectedCallback() {
    this._cleanup();
  }
  // ─── Public API (used by slideshow-v2) ────────────────────────────────
  enableParallax() {
    if (this._anim || !this._parallax || !this._inner || this._reducedMotion) return;
    if (typeof ViewTimeline !== "undefined") return;
    this._initAnimejs();
  }
  disableParallax() {
    this._cleanup();
  }
  // ─── Internal ─────────────────────────────────────────────────────────
  _initAnimejs() {
    this._inner.style.willChange = "transform";
    this._anim = waapi.animate(this._inner, {
      translateY: [`-${this._parallaxStrength}%`, "0%"],
      scale: [this._parallaxStrength / 100 + 1, this._parallaxStrength / 100 + 1],
      ease: "linear",
      composition: "replace",
      autoplay: onScroll({
        target: this,
        enter: "bottom top",
        leave: "top bottom",
        sync: true
      })
    });
  }
  _cleanup() {
    if (this._anim) {
      this._anim.revert();
      this._anim = null;
    }
    if (this._inner) {
      this._inner.style.willChange = "";
      this._inner.style.transform = "";
    }
  }
}
if (!customElements.get("media-bg-component")) {
  customElements.define("media-bg-component", MediaBg);
}
